module.exports = __webpack_public_path__ + "img/female-candidate.9c2b9e5.webp";